// Class names shared by the Lexical theme and the static renderer, so editable and read-only
// output are styled by the same rules in src/styles/content.css.
export const CONTENT_CLASSES = {
  paragraph: "ze-p",
  quote: "ze-quote",
  h1: "ze-h ze-h1",
  h2: "ze-h ze-h2",
  h3: "ze-h ze-h3",
  h4: "ze-h ze-h4",
  h5: "ze-h ze-h5",
  h6: "ze-h ze-h6",
  ul: "ze-list ze-ul",
  ol: "ze-list ze-ol",
  checklist: "ze-list ze-checklist",
  listItem: "ze-li",
  listItemChecked: "ze-li-checked",
  listItemUnchecked: "ze-li-unchecked",
  nestedListItem: "ze-li-nested",
  link: "ze-link",
  codeBlock: "ze-codeblock",
  hr: "ze-hr",
  /** The element that scrolls sideways when a table is wider than the text column. */
  tableScroll: "ze-table-scroll",
  table: "ze-table",
  tableRow: "ze-tr",
  tableCell: "ze-td",
  tableCellHeader: "ze-th",
  bold: "ze-bold",
  italic: "ze-italic",
  strikethrough: "ze-strike",
  underline: "ze-underline",
  underlineStrikethrough: "ze-underline ze-strike",
  code: "ze-code",
  highlight: "ze-mark",
  subscript: "ze-sub",
  superscript: "ze-sup",
  token: "ze-token",
  hashtag: "ze-hashtag",
  attachment: "ze-attachment",
  attachmentImage: "ze-attachment-image",
  attachmentFile: "ze-attachment-file",
  unknown: "ze-unknown",
} as const;
